import React from 'react'

const StudentSubjectCard = ({subject, student}) => {
    // const studentClass = student.class.class._id || undefined
    // const indexOfStudentClass = subject.classes.findIndex(subjectClass => subjectClass.class._id === studentClass)

    return (
        <div className='w-full rounded bg-gray-50 p-[15px] border border-gray-50'>
            <p className='font-space-grotesk font-[550] text-sm'>{subject.name} {subject.shortName && <span className='text-sm text-gray-600'>({subject.shortName})</span>}</p>
            {/* <p className='text-sm text-gray-700 mt-[5px]'>{subject.description}</p> */}
            
            <p className='text-xs text-gray-700 mt-1 mb-[5px]'>Taught by:</p>
            <p className='text-sm font-[500] text-gray-700'>{subject.teacher}</p>

        </div>
    )
}

export default StudentSubjectCard